"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListView = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var ListView = function ListView() {
  return react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.6499H0.666667C0.298477 2.6499 0 2.94838 0 3.31657V4.6499C0 5.01809 0.298477 5.31657 0.666667 5.31657H2C2.36819 5.31657 2.66667 5.01809 2.66667 4.6499V3.31657C2.66667 2.94838 2.36819 2.6499 2 2.6499ZM6 2.6499H23.3333C23.7015 2.6499 24 2.94838 24 3.31657V4.6499C24 5.01809 23.7015 5.31657 23.3333 5.31657H6C5.63181 5.31657 5.33334 5.01809 5.33334 4.6499V3.31657C5.33334 2.94838 5.63181 2.6499 6 2.6499ZM0 11.3165V12.6498C0 13.018 0.298477 13.3165 0.666667 13.3165H2C2.36819 13.3165 2.66667 13.018 2.66667 12.6498V11.3165C2.66667 10.9483 2.36819 10.6498 2 10.6498H0.666667C0.298477 10.6498 0 10.9483 0 11.3165ZM6 10.6498H23.3333C23.7015 10.6498 24 10.9483 24 11.3165V12.6498C24 13.018 23.7015 13.3165 23.3333 13.3165H6C5.63181 13.3165 5.33334 13.018 5.33334 12.6498V11.3165C5.33334 10.9483 5.63181 10.6498 6 10.6498ZM0 19.3165V20.6498C0 21.018 0.298477 21.3165 0.666667 21.3165H2C2.36819 21.3165 2.66667 21.018 2.66667 20.6498V19.3165C2.66667 18.9483 2.36819 18.6498 2 18.6498H0.666667C0.298477 18.6498 0 18.9483 0 19.3165ZM6 18.6498H23.3333C23.7015 18.6498 24 18.9483 24 19.3165V20.6498C24 21.018 23.7015 21.3165 23.3333 21.3165H6C5.63181 21.3165 5.33334 21.018 5.33334 20.6498V19.3165C5.33334 18.9483 5.63181 18.6498 6 18.6498Z",
    fill: "currentColor"
  });
};

exports.ListView = ListView;